import { render } from "./CreateOrderBatchPage.vue?vue&type=template&id=32863c25&scoped=true&ts=true"
import script from "./CreateOrderBatchPage.vue?vue&type=script&lang=ts"
export * from "./CreateOrderBatchPage.vue?vue&type=script&lang=ts"

import "./CreateOrderBatchPage.vue?vue&type=style&index=0&id=32863c25&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32863c25"]])

export default __exports__